import React from 'react'
import { NumberPad } from '@/components'
import { useAddMoneyStore } from '@/store/useAddMoneyStore'
import { useAppPreferencesStore } from '@/store/useAppPreferencesStore'
import { useGetOnRampPricePerUnit } from '@/domain'
import type { CryptoCode, FiatCode } from '@/constants/currencyCodes'

export const AddMoneyNumberPad: React.FC = () => {
  // Store state
  const isFiatMode = useAddMoneyStore((state) => state.isFiatMode)
  const fiatAmount = useAddMoneyStore((state) => state.fiatAmount)
  const cryptoAmount = useAddMoneyStore((state) => state.cryptoAmount)
  const setCryptoAmount = useAddMoneyStore((state) => state.setCryptoAmount)
  const setFiatAmount = useAddMoneyStore((state) => state.setFiatAmount)
  const selectedCurrency = useAddMoneyStore((state) => state.selectedCurrency)
  const shakeComponent = useAddMoneyStore((state) => state.shakeComponent)
  const displayCurrency = useAppPreferencesStore(
    (state) => state.displayCurrency,
  )

  // Get exchange rate from API
  const { data: onRampPricePerUnit } = useGetOnRampPricePerUnit({
    crypto: selectedCurrency?.code as CryptoCode,
    fiat: (displayCurrency?.isin as FiatCode) || 'USD',
  })

  // Use API rate or fallback to wallet rate
  const exchangeRate =
    Number(onRampPricePerUnit?.amount) || selectedCurrency?.pricePerUnit || 0

  return (
    <NumberPad
      isFiatMode={isFiatMode}
      fiatAmount={fiatAmount}
      cryptoAmount={cryptoAmount}
      setFiatAmount={setFiatAmount}
      setCryptoAmount={setCryptoAmount}
      selectedCurrency={selectedCurrency}
      exchangeRate={exchangeRate}
      shakeComponent={shakeComponent}
      maxLength={12}
    />
  )
}
